import { getCourseListPromise, getUserCourseDetailPromise } from 'api/course'
import { getTimezonesPromise } from 'api/helper'
import React, { useEffect, useState } from 'react'
import Form from './form'
import { ParamsForOption } from 'common/enum'

export default function AddUserToCourse (props) {
  const { id } = props.match.params
  const [courses, setCourses] = useState([])
  const [timezones, setTimezones] = useState([])
  const [data, setData] = useState({})

  useEffect(() => {
    getCourseListPromise({ size: 10000, ...ParamsForOption }).then(resp => setCourses(resp.rows))

    getTimezonesPromise().then(resp => setTimezones(resp))
  }, [])

  useEffect(() => {
    getUserCourseDetailPromise(id).then(resp => setData(resp))
  }, [id])

  return <Form courses={courses} timezones={timezones} data={data} {...props} />
}